import React, { createContext, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { io, Socket } from "socket.io-client";
import { RootState } from "../services/redux/store";

interface SocketProviderProps {
  children: React.ReactNode;
}

const SocketContext = createContext<Socket | null>(null);

export const useSocket = () => {
  return useContext(SocketContext);
};

export const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
  const [socket, setSocket] = useState<Socket | null>(null);

  // Replace this with your method of obtaining the token
  const { project_data, singleProject, userProfile_data } = useSelector(
    (state: RootState) => state.authStore
  );

  useEffect(() => {
    console.log("Connecting to socket server...");
    const newSocket = io(process.env.REACT_APP_API_URL?.toString() || "", {
      transports: ["websocket"],
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
      query: {
        token: project_data?.projectAccessToken,
        userDocId: userProfile_data?._id,
        projectDocId: singleProject?.projectDocId,
        phoneNumber: `91${userProfile_data?.mobileNumber}`,
      },
    });

    // console.log(`91${login_data?.username}`);

    newSocket.on("connect", () => {
      console.log("Socket connected:", newSocket.id);
    });

    newSocket.on("connect_error", (error) => {
      console.error("Connection error:", error);
    });

    newSocket.on("disconnect", (reason) => {
      console.log("Socket disconnected:", reason);
    });

    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};
